export default class ListEntityAssociatedWorkTypesError extends Error {
}
